/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: AI UGC Video Generator Landing 页面
 */
import dynamic from 'next/dynamic';
import React from 'react';

import LandingLayout from '@/landing/components/LandingLayout';
import UGCGenerator from '@/landing/components/UGCGenerator';
import {
  FAQ_CONFIG,
  FAQ_LIST,
  FEATURES_CONFIG,
  FEATURES_LIST,
  FOOTER_CTA_CONFIG,
  SEO_CONFIG,
  WHY_CHOOSE_CONFIG,
  WHY_CHOOSE_REASONS,
} from '@/landing/ugc-video-generator/config';

// 非首屏组件懒加载
const UGCVideoTypes = dynamic(
  () => import('@/landing/components/UGCGenerator/UGCVideoTypes'),
);
const UGCHowTo = dynamic(() => import('@/landing/components/UGCGenerator/UGCHowTo'));
const FeaturesSection = dynamic(
  () => import('@/landing/components/templates/FeaturesSection'),
);
const CreativeSuiteSection = dynamic(
  () => import('@/landing/components/UGCGenerator/CreativeSuiteSection'),
);
const UGCScaleSection = dynamic(
  () => import('@/landing/components/UGCGenerator/UGCScaleSection'),
);
const WhyChooseSection = dynamic(
  () => import('@/landing/components/templates/WhyChooseSection'),
);
const TikTokExploreMoreSection = dynamic(
  () => import('@/landing/components/templates/TikTokExploreMoreSection'),
);
const FAQSection = dynamic(() => import('@/landing/components/templates/FAQSection'));
const FooterCTASection = dynamic(
  () => import('@/landing/components/templates/FooterCTASection'),
);

const UGCVideoGeneratorPage: React.FC = () => {
  return (
    <LandingLayout seo={SEO_CONFIG}>
      <UGCGenerator />
      <UGCVideoTypes />
      <UGCHowTo />
      <FeaturesSection
        title={FEATURES_CONFIG.title}
        subtitle={FEATURES_CONFIG.subtitle}
        features={FEATURES_LIST}
        ctaText={FEATURES_CONFIG.ctaText}
        ctaUrl={FEATURES_CONFIG.ctaUrl}
      />
      <CreativeSuiteSection />
      <UGCScaleSection />
      <WhyChooseSection
        title={WHY_CHOOSE_CONFIG.title}
        subtitle={WHY_CHOOSE_CONFIG.subtitle}
        reasons={WHY_CHOOSE_REASONS}
        ctaText={WHY_CHOOSE_CONFIG.ctaText}
        ctaUrl={WHY_CHOOSE_CONFIG.ctaUrl}
      />
      <TikTokExploreMoreSection />
      <FAQSection title={FAQ_CONFIG.title} faqs={FAQ_LIST} />
      <FooterCTASection
        title={FOOTER_CTA_CONFIG.title}
        subtitle={FOOTER_CTA_CONFIG.subtitle}
        ctaText={FOOTER_CTA_CONFIG.ctaText}
        ctaUrl={FOOTER_CTA_CONFIG.ctaUrl}
      />
    </LandingLayout>
  );
};

export default UGCVideoGeneratorPage;
